<div class="report-view-save-modal">
  <p>{{ modalConfig.data?.updating ? 'Update this saved report view.' : 'Save the current filters as a reusable report view.' }}</p>
  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

  <label class="d-block mb-3">
    <span class="d-block mb-1">View name</span>
    <input class="form-control" [(ngModel)]="name" maxlength="200" placeholder="Quarterly performance review" />
  </label>

  <fieldset [disabled]="modalConfig.data?.updating">
    <legend class="h6">Available to</legend>
    <label class="d-block mb-2">
      <input type="radio" name="reportViewOwnership" [value]="OwnershipType.User" [(ngModel)]="ownershipType" />
      Just me
    </label>
    <label class="d-block" *ngIf="modalConfig.data?.canShareWithFlightSchool">
      <input type="radio" name="reportViewOwnership" [value]="OwnershipType.FlightSchool" [(ngModel)]="ownershipType" />
      Everyone at my flight school
    </label>
    <label class="d-block" *ngIf="modalConfig.data?.canSaveSystem">
      <input type="radio" name="reportViewOwnership" [value]="OwnershipType.System" [(ngModel)]="ownershipType" />
      Recommended for all users
    </label>
  </fieldset>
</div>
